module.exports = __webpack_public_path__ + "media/images/gallery/oc_l-afe65b05ab1d1b5be9854c1874c7ee21.gif";